export const api = {
  base: 'https://api.baspo.exigo.ch'
}

export const gameParams = {
  maxMinorAccidents: 3,
  wheelSpinDuration: 6
}
